/* 數字模板 ---> 零用金 / 抽屜現金 / 雜支 / 數量 / 容量自訂金額 / 旺卡加退值 / 黃金點數 / 購物袋 */
<template>
  <cus-dialog>
    <template v-slot:body>
      <div :class="['computer', cusProps.hasSpeedBtn ? 'has-speed-button' : '']">
        <!-- note說明 -->
        <div v-if="cusProps.hasNote" class="computer-note">
          <p>{{ cusProps.note }}</p>
        </div>
        <!-- 顯示欄位 -->
        <div class="compute-number">
          <cus-button
            v-if="name === 'quantity'"
            color="blue"
            topIcon="dash-lg"
            buttonClass="num-icon"
            @click="computeNum -= 1"
            :disabled="computeNum === 0"
          ></cus-button>
          <p class="result">{{ computeNum }}</p>
          <cus-button
            v-if="name === 'quantity'"
            color="blue"
            topIcon="plus-lg"
            buttonClass="num-icon"
            @click="computeNum += 1"
          ></cus-button>
        </div>
        <!-- 快速鍵 -->
        <div v-if="cusProps.hasSpeedBtn">
          <cus-button
            :text="cusProps.buttonText + '：' + cusProps.speedNumber"
            color="green"
            @click="computeNum = cusProps.speedNumber"
          ></cus-button>
        </div>
        <!-- 數字鍵 -->
        <div class="number-button">
          <cus-button v-for="num in 9" :key="num" :text="num.toString()" @click="handleNumber(num)"></cus-button>
          <cus-button v-if="cusProps.hasHundred" text="00" @click="handleNumber('00')"></cus-button>
          <cus-button
            text="0"
            :style="cusProps.hasHundred ? '' : 'grid-area: 4/1/5/3'"
            @click="handleNumber(0)"
          ></cus-button>
          <cus-button
            topIcon="arrow-left"
            topIconClass="back-arrow"
            @click="handleBack"
            :disabled="computeNum === 0"
          ></cus-button>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="取消" color="white" :width="50" @click="close"></cus-button>
        <cus-button
          :text="style.confirmButtonText || '確認'"
          :color="style.confirmButtonColor || 'blue'"
          :width="50"
          :disabled="computeNum <= (cusProps.disableMin || 0)"
          @click="submit(computeNum)"
        ></cus-button>
      </div>
    </template>
  </cus-dialog>
</template>
<script>
import { ref, inject, watch } from 'vue';
export default {
  name: 'computer',
  setup() {
    //接受provide值
    const dialogVisible = inject('dialogVisible', false);
    const name = inject('name');
    const close = inject('close');
    const submit = inject('submit');
    const { cusProps } = inject('cusProps');
    const { style } = inject('style');
    //設定參數
    const hasCompute = ref(false); //控管第一次按
    const computeNum = ref(0); //顯示數值
    //設定初始值
    if (dialogVisible) {
      if (cusProps.init) computeNum.value = JSON.parse(JSON.stringify(cusProps.init));
    }
    //恢復初始值
    watch(dialogVisible, () => {
      hasCompute.value = false;
      computeNum.value = 0;
    });

    //按數字
    const handleNumber = (num) => {
      //限制字數
      if (computeNum.value.toString().length === 5 && name.value === 'quantity') return;
      else if (computeNum.value.toString().length === 13) return;
      let str_num = num.toString();
      let str_compute = computeNum.value === 0 || !hasCompute.value ? '' : computeNum.value.toString();
      computeNum.value = Number(str_compute + str_num);
      hasCompute.value = true;
    };
    //消除數字
    const handleBack = () => {
      let str_compute = computeNum.value.toString();
      if (str_compute.length === 1) {
        computeNum.value = 0;
      } else {
        computeNum.value = Number(str_compute.slice(0, -1));
      }
      hasCompute.value = true;
    };
    return { name, close, submit, cusProps, style, hasCompute, computeNum, handleNumber, handleBack };
  },
};
</script>
<style lang="scss" scoped>
.computer {
  @include computer-basic;
}
.computer-note {
  position: absolute;
  top: -18px;
  width: 100%;
  text-align: center;
}
.has-speed-button {
  grid-template-rows: 0.7fr 0.5fr 4fr;
}
</style>
